<template>
  <modal
    width="380px"
    speed="fast"
    noOutClose
    maskNoClick
    :show="show"
    enter-active-class="fadeIn"
    leave-active-class="fadeOut"
    @update:show="close"
    class="detect-tip-modal"
  >
    <p slot="header">提示</p>
    <p slot="content" class="text">
      您尚未通过设备检测，若因设备检测未通过而影响正常考试，由考生自行承担后果，是否继续进入考试？
    </p>
    <div slot="footer">
      <button
        class="blue-btn"
        @click="close">取消</button>
      <button class="white-btn" @click="goTest">确定</button>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/Modal'
export default {
  components: {
    Modal
  },
  data() {
    return {
      show: true
    }
  },
  methods: {
    goTest() {
      this.$emit('goTest')
      this.close()
    },
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
  /deep/ .modal-head {
    padding: 16px 20px;
    border-bottom: 1px solid #F1F1F1;
  }
  .white-btn {
    @include cancel-btn(96px, 36px, 14px, 4px);
    margin-bottom: 10px;
  }
  .blue-btn {
    @include theme-fill-btn(96px, 36px, 14px, 4px);
    margin-right: 20px;
  }
  .text {
    font-size: 16px;
    margin: 10px 0;
  }
</style>
